import axios from 'axios'

const state = {
  sendings: [],
  sending: {}
}

const getters = {
  sendings: state => state.sendings,
  sending: state => state.sending
}

const mutations = {
  sendings: (state, sendings) => state.sendings = sendings,
  sending: (state, sending) => state.sending = sending
}

const actions = {
  LOAD_SENDINGS: async ctx => {
    try {
      const { data: sendings } = await axios.get('/sendings')
      if (sendings.length) ctx.commit('sendings', sendings)
    } catch (err) {
      console.error(err)
    }
  },
  LOAD_SENDING: async (ctx, id) => {
    try {
      const { data: sending } = await axios.get(`/sendings/${id}`)
      if (sending) ctx.commit('sending', sending)
    } catch (err) {
      console.error(err)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}